export const appGoalIcon = {
  data: `<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.5 5.5C28.508 5.5 35 11.992 35 20C35 28.008 28.508 34.5 20.5 34.5C12.492 34.5 6 28.008 6 20C6 11.992 12.492 5.5 20.5 5.5Z" stroke="#02065B" stroke-width="5"/>
    <path d="M20.5 14.5C23.5375 14.5 26 16.9625 26 20C26 23.0375 23.5375 25.5 20.5 25.5C17.4625 25.5 15 23.0375 15 20C15 16.9625 17.4625 14.5 20.5 14.5Z" stroke="#02065B" stroke-width="5"/>
  </svg>`,
  name: 'goal'
};
